import { render } from "./P082.vue?vue&type=template&id=132c0d20&scoped=true"
import script from "./P082.vue?vue&type=script&lang=js"
export * from "./P082.vue?vue&type=script&lang=js"

import "./P082.vue?vue&type=style&index=0&id=132c0d20&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132c0d20"]])

export default __exports__